export default __webpack_public_path__ + "static/media/microphone-unmute.272faa7a.svg";